import React, { useState } from 'react';
import { ChevronDown } from 'react-feather';
import PinPost from './Config/Pin';
import ShareProfile from './Config/ShareProfile/ShareProfile';
import PostActions from './EditAndDelete';
import BlockUser from './Config/BlockUser';
import MuteUser from './Config/MuteUser';
import NotInterested from './Config/NotInterested';
import Report from './Config/Report';
import CommentAutoReplyManager from './Config/CommentAutoReply';
import { Post } from '../../types';
import BottomSheet from '../bottom-sheet/bottom-sheet';
import { ArchiveRestore, ArchiveX, Share2, Trash2, Volume2 } from 'lucide-react';
import { useAuth, useMessage } from '../../global-components/src';
import axios from 'axios';
import { PACOCA_API_URL } from '../../global-components/src/utils/vars';
import { errorMessage, speak } from '../../global-components/src/utils/text';
import PermissionCheck from '../PermissionCheck';
import { SiArchiveofourown } from 'react-icons/si';
import { t } from 'i18next';
import { detectLanguage, langToListen } from '../../global-components/src/utils/language';
import { hasPosition, isVerifyed } from '../../global-components/src/utils/auth';

interface PostProps {
    post?: Post;
    onDelete?: (post: Post) => void;
    onRestore?: (post: Post) => void;
    onEdit?: (post: Post) => void;
    onReport?: (removeReport: boolean, id_user: number, id_post: number) => void;
}

const DropdownPost: React.FC<PostProps> = ({ onDelete, onEdit, onRestore, post, onReport }) => {
    const [openSettings, setOpenSettings] = useState(false);

    return (
        <>
        {post ? (
            <div className="col-1 col-conf-post">
                <div className="dropdown">
                    <button className='none-cel' aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                        <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                    </button>
                    
                    <button className='none-pc' aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" onClick={() => setOpenSettings(true)} >
                        <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                    </button>

                    <ul className="dropdown-menu menu-drop none-mobile" style={{ minWidth: "250px" }}>
                       <OptionsDrop post={post} onDelete={onDelete} onEdit={onEdit} onRestore={onRestore} onReport={onReport}/> 
                    </ul>
                </div>

                <BottomSheet disableDrag={true} snapPoints={[0, 0.45, 1]} initialSnap={1} setOpen={setOpenSettings} open={openSettings}>
                    <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                        <div className="modal-content modal-content-likes" id="modal-content-likes">
                            <div className="modal-header modal-header-comments">
                                <div></div>
                            </div>
                            <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings" style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenSettings(false)}>
                               <OptionsDrop post={post} onDelete={onDelete} onEdit={onEdit} onRestore={onRestore} onReport={onReport}/> 
                            </div>
                        </div>
                    </div>
                </BottomSheet>
            </div>
        ) : null}
        </>
    );
};

const OptionsDrop = ({ post, onEdit, onDelete, onRestore, onReport }: PostProps) => {
    const { setMessage } = useMessage();
    const { user, token, isSuper, isMaster } = useAuth();
    const [approved, setApproved] = useState(false);
    const [reproved, setReproved] = useState(false);

    const copyLinkUser = () => {
        const link = `${window.location.origin}/posts/${post?.id}`;
        
        if (navigator.share) {
            navigator.share({
                title: `Compartilhar ${post?.id}`,
                url: link,
            }).catch((error) => console.error('Erro ao compartilhar o link:', error));
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link)
                .then(() => setMessage("Link copiado", "success"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        } else {
            alert('Copie este link: ' + link);
        }
    };

    const aproveAds = async() => {
        try {
            await axios.post(`${PACOCA_API_URL}/moderators/ads/approve/${post?.ads?.id}`, {},{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            setMessage('Anúncio aprovado', "success");
            setApproved(true);
            
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error")
            console.error("Erro criar anuncio: ", messageError);
            console.error("Erro criar anuncio: ", err);
        } 
    }

    const reproveAds = async() => {
        try {
            await axios.post(`${PACOCA_API_URL}/moderators/ads/reprove/${post?.ads?.id}`, {},{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            setMessage('Anúncio reprovado, o dono será notificado', "success");
            setApproved(true);
            
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error")
            console.error("Erro criar anuncio: ", messageError);
            console.error("Erro criar anuncio: ", err);
        } 
    }

    return (
        <>
            {post && (!post.ads || (post.ads.status != "validando_conteudo" && !post.ads.status.includes("Reprovado"))) ? (
                <>
                {!post.deleted_at ? (
                    <>
                        <PinPost post={post} />
                        {user && user.id === post.id_user && (isVerifyed(user) || hasPosition(user)) && (
                            <CommentAutoReplyManager postId={post.id} />
                        )}
                    </>
                ): null}
                
                <ShareProfile user_name={post?.user?.user_name} />

                {post.deleted_at ? (
                    <li>
                        <span className="dropdown-item cursor-pointer user-select-none" onClick={() => onRestore ? onRestore(post) : {}}>
                            <div className="div-icon-fix">
                                <div className="div-icon-block">
                                    <ArchiveRestore data-feather="copy" className="icon-config-post"/>
                                    {t("post.actions.restore")}
                                </div> 
                            </div> 
                        </span>
                    </li>
                ): null}

                {!post.deleted_at || (post.deleted_at && (user && (user.id == post?.user?.id || user.id < 3))) ? (
                    <>
                        <PostActions userOwner={post?.user} post={post} onEdit={onEdit ? onEdit : () => {}} onDelete={onDelete ? onDelete : () => {}} />
                    </>
                ): (
                    <>
                        <li>
                            <span className="dropdown-item cursor-pointer user-select-none" onClick={copyLinkUser}>
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <Share2 data-feather="copy" className="icon-config-post"/>
                                        {t("post.actions.copyPost")}
                                    </div> 
                                </div> 
                            </span>
                        </li>
                    </>
                )}

                <BlockUser is_blocked={post?.user_is_blocked} id_user={post?.user?.id} />
                <MuteUser is_muted={post?.user_is_muted ?? false} id_user={post?.user?.id} />
                {!post.deleted_at ? (
                    <NotInterested id_post={post.id} id_user={post.id_user} tags={post.tags} />
                ) : null}
                
                
                {!!post?.text?.length && "speechSynthesis" in window && (
                    <li>
                        <span className="dropdown-item cursor-pointer user-select-none" onClick={() => speak(post.text ?? "", langToListen(detectLanguage(post.text)))}>
                            <div className="div-icon-fix">
                                <div className="div-icon-block">
                                    <Volume2 data-feather="copy" className="icon-config-post"/>
                                    {t("post.actions.listenPost")}
                                </div> 
                            </div> 
                        </span>
                    </li>
                )}
                
                {!post.deleted_at ? (
                    <Report alreadyReported={post?.reported} onReport={(report) => onReport ? onReport(report, post?.user?.id, post?.id) : {}} post={post} />
                ): null}
                </>
            ): null}

            {(post?.ads?.status == "validando_conteudo" || post?.ads?.status.includes("Reprovado")) && (user?.position || (user && isMaster(true))) ? (
                <>
                    <PermissionCheck permission="delete_post" id_owner={post?.id_user}>
                        {post?.user && user && (user?.position < post?.user?.position || !post?.user?.position && user?.position || isSuper(true) || user.id == post.id_user) ? (
                            <li>
                                <span onClick={() => onDelete ? onDelete(post) : {}} className="dropdown-item cursor-pointer user-select-none" style={{display: "flex", alignItems: "center"}}>
                                    <Trash2 data-feather="edit" className="icon-config-post"/> {t("post.actions.delete")}
                                </span>
                            </li>
                        ) : null}
                    </PermissionCheck>
                
                    {!approved && !reproved && (
                        <li>
                            <span className="dropdown-item cursor-pointer user-select-none" onClick={aproveAds}>
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <ArchiveRestore data-feather="copy" className="icon-config-post"/>
                                        {t("post.actions.approveAds")}
                                    </div> 
                                </div> 
                            </span>
                        </li>
                    )}
                
                    {!approved && !reproved && !post?.ads?.status.includes("Reprovado") && (
                        <li>
                            <span className="dropdown-item cursor-pointer user-select-none" onClick={reproveAds}>
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <ArchiveX data-feather="copy" className="icon-config-post"/>
                                        {t("post.actions.reproveAds")}
                                    </div> 
                                </div> 
                            </span>
                        </li>
                    )}
                </>
            ): null}
        </>
    );
}

export default DropdownPost;